export const tasks = [
    {
        id: '0',
        qualtricsLink:'https://hku.au1.qualtrics.com/jfe/form/SV_a8AahGJA12xHVeS',
        day: 0
    },
    {
        id: '1',
        youtubeLink:'PB68Qf9slq8',
        title: 'When you learned about the flight or fight response, did any specific personal memory come up?',
        subtitle: 'If no, think of one right now that applies and talk about how that affected you emotionally when it happened.',  
        day: 0
    },
    {
        id: '2',
        youtubeLink:'-D--Oe-SeiM',
        title: 'When the lecturer talked about different sources of stress, what thoughts came to mind?',
        subtitle: 'Did any specific memory come up? Discuss your thoughts and emotions to varying sources of stress in your life.',
        day:2
    },
    {
        id: '3',
        youtubeLink:'g8qCl4w5PGA',
        title: 'The lecturer mentioned different ways that your physical health and practices could interact with your anxiety.',
        subtitle: 'Reflect on how this applies to your life and how long it has been going on. Discuss it and focus on how this relationship can become cyclical',
        day:4
    },
    {
        id: '4',
        youtubeLink:'-4PapBr6mjM',
        title: 'The lecturer discussed how many of our anxieties can stem from different stresses. Think in the past two weeks about what was one of the largest stress contributor to your sense of anxiety?',
        subtitle: 'What happened and how does it affect you?',
        day:6
    },
    {
        id: '5',
        qualtricsLink:'https://hku.au1.qualtrics.com/jfe/form/SV_a8AahGJA12xHVeS',
        day:7
    },
    {
        id: '6',
        youtubeLink:'Km3JK9BGT58',
        title: 'Did you feel more relieved after hearing about the different types of anxiety disorders and their symptoms?',
        subtitle: 'Reflect on what you can do with this new information and whether you see there being any personal real life application to this knowledge',
        day:8
    },
    {
        id: '7',
        youtubeLink:'XhEbJ5DQ84Y',
        title: 'A large portion of the video discusses how anxiety may manifest with physical symptoms and how that might push us to act differently.',
        subtitle: 'Take a moment to reflect on this idea and reflect on how the physical world, your health, and your anxiety may interact. Discuss a specific instance that has affected you.',
        day:10
    },
    {
        id: '8',
        youtubeLink:'WjKtK4SJilM',
        title: 'Today’s session discussed a lot about the different available treatments for anxiety. Reflect on the different strategies you have used in the past to handle your stress or anxiety.',
        subtitle: 'Think about an instance that worked and think of an instance that did not work.',
        day:12
    },
    {
        id: '9',
        qualtricsLink:'https://hku.au1.qualtrics.com/jfe/form/SV_5p4Wcan3jE48LSC',
        day:13
    },
    {
        id: '10',
        youtubeLink:'LQVG0YQ8RCA',
        title: 'Today we looked at depression instead of anxiety. A large part of the lecture focused on cognitive distortions (black and white thinking, personalization, catastrophizing, etc.). When you learnt of these thinking patterns, were you able to relate it to your own personal journey?',
        subtitle: 'Try to remember an incident that impacted you greatly and how these thought patterns may have contributed to it.',
        day:14
    },
    {
        id: '11',
        youtubeLink:'UYNtXTvoFIM',
        title: 'Today’s video focuses on the different treatments for treating depression. These interventions focus on relationships, behaviors, and your thoughts.',
        subtitle: 'Reflect on your current stressors and how they have affected these three areas.',
        day:16
    },
    {
        id: '12',
        youtubeLink:'2zdkiGhv-_A',
        title: 'Today we looked at the black dog video. Do you feel like this black dog metaphor is reflective of your current experiences? Why or why not?',
        subtitle: '',
        day:18
    },
    {
        id: '13',
        youtubeLink:'V_ayfH_GshY',
        title: 'That wraps up the lecture series for depression and anxiety. Take this moment to reflect on everything you’ve learnt. Did you feel relieved with learning these new theories and approaches towards mental health?',
        subtitle: 'Did you perhaps feel frustrated because you did not feel that it applied to your experience? Discuss.',
        day:20
    },
    {
        id: '14',
        qualtricsLink:'https://hku.au1.qualtrics.com/jfe/form/SV_b44G3sy7L854kLk',
        day:22
    },   
]
